import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Download"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-download',
    templateUrl: './icon-download.component.html',
    styleUrls: ['./icon-download.component.scss'],
    standalone: false
})
export class IconDownloadComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
